import React from 'react';
import PropTypes from 'prop-types';

import { StyledReportList } from './style';
import { ContentGrouping } from '../../core/ContentGrouping';

import ShareReportItem from './shareReportItem';

const ShareReport = ({ data, date, onClickIconShare }) => (
  <ContentGrouping title={`Descarga de informes completos del día ${date}`}>
    <StyledReportList>
      {data &&
        data.map(item => (
          <ShareReportItem
            key={item.name}
            data={item}
            onClickIconShare={(pdfUrl, pdfName, xlsUrl, xlsName) => {
              onClickIconShare(pdfUrl, pdfName, xlsUrl, xlsName);
            }}
          />
        ))}
    </StyledReportList>
  </ContentGrouping>
);

ShareReport.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      pdf: PropTypes.string,
      xls: PropTypes.string
    })
  ).isRequired,
  date: PropTypes.string.isRequired,
  onClickIconShare: PropTypes.func
};

export default ShareReport;
